export default __webpack_public_path__ + "static/media/FordMustang.cb34d0b5.png";